import{useContext}from'react';import{FulfillmentSelectorContext}from"./FulfillmentSelector.context";/**
 * @returns {Object} The fulfillment selector context.
 */export function useFulfillmentSelectorState(){return useContext(FulfillmentSelectorContext);}